var indentStyle = {"indentZero":"DNLHv","indentOne":"VIIln","indentTwo":"QBdEX","indentThree":"kHjG-","indentFour":"OxHoB","indentFive":"_0YbFY","indentSix":"-LNSZ"};

export { indentStyle as i };
//# sourceMappingURL=indentation-aefa69b2.js.map
